<template>
  <div v-if="displayDnsOptions.length">
    <h6
      v-if="!hideTitle && displayDnsOptions.length > 1"
      class="text--heading font-weight-bold mb-4"
    >
      {{ $t("heading.instance.modal.setDomain.config.title") }}
    </h6>
    <div>
      <v-expansion-panels v-model="panel" class="v-expansion-panels--dns p-sm" v-if="showARecordInfo || showCNAMERecordInfo || showNameserversInfo || showDnsRecordsFromDnsServerInfo">
        <v-expansion-panel expand v-model="panel" v-if="showARecordInfo || showDnsRecordsFromDnsServerInfo">
          <v-expansion-panel-header class="p-d font-weight-600" disable-icon-rotate>
              {{ $t("heading.instance.modal.setDomain.config.tab.dnsRecords.title") }}
            <template v-slot:actions>
              <v-icon color="darken1" :size="16">$plus</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <ol>
              <li>
                {{ $t("heading.instance.modal.setDomain.config.tab.dnsRecords.list.first") }}
              </li>
              <li>
                {{ $t("heading.instance.modal.setDomain.config.tab.dnsRecords.list.second") }}
                <div v-if="showARecordInfo">
                  <div
                    v-for="(ipAddress, index) in ipv4AddressesToDisplay"
                    :key="index"
                    class="well p-d pa-3 mt-1"
                  >
                    <span>
                      {{ $t("general.name") }}:
                      <strong>{{ computedDomain }}</strong>
                      ({{ $t("general.or") }} <strong>@</strong>) <br />{{ $t("general.type") }}:
                      <strong>A</strong>
                      <br />{{ $t("general.address") }}:
                      <strong>{{ ipAddress }}</strong>
                    </span>
                  </div>
                  <div class="well p-d pa-3 mt-1">
                    {{ $t("general.name") }}:
                    <strong>www.{{ computedDomain }}</strong>
                    <br />{{ $t("general.type") }}:
                    <strong>CNAME</strong>
                    <br />{{ $t("general.address") }}:
                    <strong>{{ computedDomain }}</strong>
                  </div>
                </div>
                <div v-if="showDnsRecordsFromDnsServerInfo">
                  <div
                    v-for="(record, index) in dnsServerRecordsToDisplay"
                    :key="index"
                    class="well p-d pa-3 mt-1"
                  >
                    <span>
                      {{ $t("general.name") }}:
                      <strong>{{ record.name }}</strong>
                      <br />{{ $t("general.type") }}:
                      <strong>{{ record.type }}</strong>
                      <br />{{ $t(`general.${getRecordTypeLabel(record.type)}`) }}:
                      <strong>{{ record.value }}</strong>
                    </span>
                  </div>
                </div>
              </li>
              <li>
                {{ $t("heading.instance.modal.setDomain.config.tab.dnsRecords.list.third") }}
              </li>
            </ol>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-model="panel" v-if="showCNAMERecordInfo">
          <v-expansion-panel-header class="p-d font-weight-600" disable-icon-rotate>
              {{ $t("heading.instance.modal.setDomain.config.tab.cnameRecords.title") }}
            <template v-slot:actions>
              <v-icon color="gray" :size="16">$plus</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <ol>
              <li>
                {{ $t("heading.instance.modal.setDomain.config.tab.dnsRecords.list.first") }}
              </li>
              <li>
                {{ $t("heading.instance.modal.setDomain.config.tab.dnsRecords.list.second") }}
                <div class="well p-d pa-3 mt-1">
                  <span>
                    {{ $t("general.name") }}:
                    <strong>{{ computedDomain }}</strong>
                    ({{ $t("general.or") }} <strong>@</strong>) <br />{{ $t("general.type") }}:
                    <strong>CNAME</strong>
                    <br />{{ $t("general.address") }}:
                    <strong>{{ onboardingSubdomain }}</strong>
                    <br />---<br />
                  </span>
                </div>
                <div class="well p-d pa-3 mt-1">
                  {{ $t("general.name") }}:
                  <strong>www.{{ computedDomain }}</strong>
                  <br />{{ $t("general.type") }}:
                  <strong>CNAME</strong>
                  <br />{{ $t("general.address") }}:
                  <strong>{{ computedDomain }}</strong>
                </div>
              </li>
              <li>
                {{ $t("heading.instance.modal.setDomain.config.tab.dnsRecords.list.third") }}
              </li>
            </ol>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-model="panel" v-if="showNameserversInfo">
          <v-expansion-panel-header class="p-d font-weight-600" disable-icon-rotate>
              {{ $t("heading.instance.modal.setDomain.config.tab.nameservers.title") }}
            <template v-slot:actions>
              <v-icon color="gray" :size="16">$plus</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <ol class="mb-4">
              <li>{{ $t("heading.instance.modal.setDomain.config.tab.dnsRecords.list.first") }}</li>
              <li v-if="currentNameservers.length > 0">
                <span>{{ $t("heading.instance.modal.setDomain.config.tab.nameservers.list.first") }}</span>
                <div class="well p-d pa-3 mt-1" v-for="(ns, index) in currentNameservers" :key="index">
                  <strong>{{ ns }}</strong>
                </div>
              </li>
              <li>
                <span>{{ $t("heading.instance.modal.setDomain.config.tab.nameservers.list.second") }}</span>
                <div class="well p-d pa-3 mt-1" v-for="(ns, index) in nameservers" :key="index">
                  <strong>{{ ns }}</strong>
                </div>
              </li>
              <li>
                {{ $t("heading.instance.modal.setDomain.config.tab.nameservers.list.third") }}
              </li>
            </ol>

            <div class="mt-4 mb-2">
              <strong class="mr-1">{{ $t("heading.instance.modal.setDomain.config.tab.nameservers.list.note_label") }}</strong>
              <span>{{ $t("heading.instance.modal.setDomain.config.tab.nameservers.list.note_text") }}</span>
            </div>

            <div class="mt-4 mb-2">
              <span>{{ $t("heading.instance.modal.setDomain.config.tab.nameservers.list.learn_more_text") }}</span>
              <a
                class="ml-1"
                href="https://www.panelalpha.com/documentation/"
                target="_blank"
                rel="noopener"
              >{{ $t("heading.instance.modal.setDomain.config.tab.nameservers.list.learn_more_link") }}.</a>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    domain: String,
    onboardingSubdomain: [String, null],
    dnsSettings: Object,
    hasDnsServer: Boolean,
    ipv4Addresses: Array,
    nameservers: Array,
    hostCNames: {
      type: Array,
      default: () => [],
    },
    dnsServerRecords: {
      type: Array,
      default: () => [],
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      infoTab: null,
      panel: 0,
      currentNameservers: [],
    };
  },
  computed: {
    displayDnsOptions() {
      let options = this.dnsSettings.display_options;
      if (!Array.isArray(options)) {
        return [];
      }
      return options;
    },
    showARecordInfo() {
      return this.displayDnsOptions.includes("a_records");
    },
    showCNAMERecordInfo() {
      if (!this.onboardingSubdomain) {
        return false;
      }
      return this.displayDnsOptions.includes("cname_record");
    },
    showNameserversInfo() {
      if (!this.hasDnsServer) {
        return false;
      }
      if (!this.nameservers.length) {
        return false;
      }
      return this.displayDnsOptions.includes("ns_records");
    },
    showDnsRecordsFromDnsServerInfo() {
      if (!this.dnsServerRecords?.length && !this.hostCNames?.length) {
        return false;
      }
      return this.displayDnsOptions.includes("records_from_dns_server");
    },
    computedDomain() {
      if (this.domain.startsWith('www.')) {
        return this.domain.slice(4);
      }
      return this.domain;
    },
    ipv4AddressesToDisplay() {
      const ips = [];
      this.ipv4Addresses.forEach((ip) => {
        if (!ip.includes('/')) {
          ips.push(ip);
        }
      })
      return ips;
    },
    dnsServerRecordsToDisplay() {
      const records = this.dnsServerRecords;
      const cnameRecords = this.hostCNames.map((cname) => {
        return {
          name: this.domain,
          type: 'CNAME',
          value: cname,
        }
      })
      return records.concat(cnameRecords);
    }
  },
  methods: {
    getRecordTypeLabel(type) {
      if (type === 'A' || type === 'AAAA' || type === 'CNAME') {
        return 'address';
      }
      return 'value';
    },
    async resolveNSRecordsByRDAP(domain) {
      return fetch(`https://rdap.org/domain/${domain}`, {
        referrerPolicy: 'no-referrer',
        cache: 'no-cache',
      }).then((response) => {
        return response.json();
      }).then((jsonResponse) => {
        let nameservers = [];
        if (jsonResponse.nameservers) {
          for (const ns of jsonResponse.nameservers) {
            nameservers.push(ns.ldhName);
          }
        }
        return nameservers;
      }).catch(() => {
        return [];
      });
    },
  },
  async mounted() {
    if (this.showNameserversInfo) {
      this.currentNameservers = await this.resolveNSRecordsByRDAP(this.domain);
    }
  },
};
</script>

<style lang="scss" scoped>
.v-card__text {
  -webkit-line-clamp: unset;
}

.v-expansion-panel {
  border: 1px solid var(--v-gray-lighten2);

  &::before {
    display: none;
  }

  &::after {
    display: none;
  }

  &--active {
    border-color: var(--v-primary-base);
  }

  .v-expansion-panel-content::v-deep {
    .v-expansion-panel-content__wrap {
      padding-bottom: 0px;
    }
  }

  .v-expansion-panel-header {
    padding-left: 60px;
    position: relative;

    &::before,
    &::after {
      content: "";
      position: absolute;
      left: 24px;
      top: 50%;
      transform: translateY(-50%);
      opacity: 1 !important;
      background: white;
      border-radius: 20px;
    }

    &::before {
      transition: border-color 0.24s ease, background-color 0.24s ease;
      width: 20px;
      height: 20px;
      border: 1px solid var(--v-gray-base);
    }

    &::after {
      width: 10px;
      height: 10px;
      z-index: 10;
      left: 29px;
    }

    &:hover {
      &::before {
        border-color: #07c07e;
      }
    }

    &--active {
      &:before {
        border-color: #07c07e;
        background-color: #07c07e;
      }
    }
  }
}

.domain-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 6px;
  border: 1px solid var(--v-gray-lighten2);
  padding: 16px 16px;
  margin-bottom: 16px;
}

.domain-info {
  border-radius: 6px;
  border: 1px solid var(--v-gray-lighten2);
  padding: 6px 16px 16px 16px;
  background: #fafafa;
  margin-bottom: 24px;
}

.recovery-code-box {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 60px;
  color: var(--v-primary-base);
  background: rgba(7, 192, 126, 0.05);
  border-radius: 6px;
  text-transform: uppercase;
  font-weight: $font-weight-bold;
  word-wrap: anywhere;
  padding: 8px;
  min-height: 80px !important;
}
</style>